import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TerminalType } from "../../../../../../../../../../../services/Api/Organization/types";
import { terminalsUpgradeEnabled } from "../../../../../../../../../../../utils/envutil";
import TerminalLicenseIcon from "../../../components/TerminalLicenseIcon";
import { TerminalToUpdate, getTerminalTypeTitle } from "../../../utils";
import UpgradeTerminalModal from "./UpgradeTerminalModal";

interface Props {
	type: TerminalType;
	accessAmount: number;
	propertyAmount: number;
	isManualLicense?: boolean;
}

const TerminalStatisticsCard = ({ accessAmount, propertyAmount, type, isManualLicense }: Props) => {
	const { t } = useTranslation();
	const [terminalToUpgrade, setTerminalToUpgrade] = useState<TerminalToUpdate | undefined>();
	const isLicenseEnabled = propertyAmount > 0 || accessAmount > 0;

	const getVariant = () => {
		if (isManualLicense) return "primary";
		if (propertyAmount > accessAmount) return "danger";
		if (propertyAmount === accessAmount) return "primary";
		return undefined;
	};

	const handleLicense = () => {
		return setTerminalToUpgrade({
			type,
			accessAmount,
			propertyAmount,
		});
	};

	return (
		<>
			<Card className="card-box terminal-statistics-card">
				<Card.Body>
					<div className="d-flex align-items-center gap-2 mb-2">
						<TerminalLicenseIcon type={type} variant={isLicenseEnabled ? getVariant() : undefined} />
						<h5 className="card-header-title">{getTerminalTypeTitle(type, t)}</h5>
					</div>
					{isLicenseEnabled ? (
						<>
							{terminalsUpgradeEnabled() && (
								<div className="d-flex flex-nowrap align-items-center">
									<p
										className={`mb-0 font-weight-bold ${
											getVariant() === "danger" ? "text-danger" : "text-muted"
										} me-1`}
									>
										{t("modules.terminal.field.licenses.title")}:
									</p>
									<span className="font-weight-bold">
										<span
											className={`${getVariant() === "danger" ? "text-danger" : "text-primary"}`}
										>
											{propertyAmount}
										</span>
										{!isManualLicense && <span className="text-primary">/{accessAmount}</span>}
									</span>
								</div>
							)}
							<Button
								className="w-100 mt-2 px-4"
								variant={!getVariant() ? "light" : "primary"}
								onClick={handleLicense}
							>
								{t("modules.terminal.action.increase_license.title")}
							</Button>
						</>
					) : (
						<div className="d-flex flex-column gap-2">
							<Button className="px-4" onClick={handleLicense}>
								{t("modules.terminal.action.buy_license.title")}
							</Button>
							<Button variant="add" className="px-4">
								{t("lib:common.action.learn_more")}
							</Button>
						</div>
					)}
				</Card.Body>
			</Card>
			{terminalToUpgrade && (
				<UpgradeTerminalModal
					show={!!terminalToUpgrade}
					terminal={terminalToUpgrade}
					onHide={() => setTerminalToUpgrade(undefined)}
				/>
			)}
		</>
	);
};

export default TerminalStatisticsCard;
